import { Injectable } from '@angular/core';
import { Response, RequestOptions, Headers } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { WebService } from '../../employee/service/web.service';
import { tokenNotExpired } from 'angular2-jwt';

@Injectable()
export class CandidateDisabilitiesService extends WebService{

  public newCandidateDisabilitie(formData: FormData): Observable<Response> {
    var headers: Headers = new Headers();
    if (tokenNotExpired()) {
        headers.append('Authorization', 'Bearer ' + localStorage.getItem('token'));
    }
    var options = new RequestOptions({ headers: headers });

    return this.http.post(`${this.apiUrl}/candidate-disabilitie/`, formData, options);
  }

  public getCandidateDisabilities(candidate_id: number, page?: number, per_page?: number, sort?: string, query?: string, filters?: any[]): Observable<Response> {
    let params: URLSearchParams = new URLSearchParams();

    if (page !== null && page !== undefined) {
        params.append('_page', String(page));
    } else {
        params.append('_page', '1');
    }

    if (per_page !== null && per_page !== undefined) {
        params.append('_limit', String(per_page));
    } else {
        params.append('_limit', '10');
    }

    if (sort !== null && sort !== undefined) {
        params.append('_sort', String(sort));
    }

    if (query !== null && query !== undefined && query !== '') {
        params.append('_q', String(query));
    }

    if (filters !== null && filters !== undefined && filters.length > 0) {
        filters.forEach(element => {
            params.append(element.key, String(element.value));
        });
    }

    params.append('candidate_id', String(candidate_id));

    const options = new RequestOptions({ search: params, headers: this.headers });

    return this.http.get(`${this.apiUrl}/candidate-disabilities/${candidate_id}?${params}`, options);
  }

  public getDisability(page?: number, per_page?: number, sort?: string, query?: string, filters?: any[]): Observable<Response> {
    let params: URLSearchParams = new URLSearchParams();

    if (page !== null && page !== undefined)
      params.append('_page', String(page));
    else
      params.append('_page', '1');

    if (per_page !== null && per_page !== undefined)
      params.append('_limit', String(per_page));
    else
      params.append('_limit', '10');

    if (sort !== null && sort !== undefined)
      params.append('_sort', String(sort));

    if (query !== null && query !== undefined && query !== '')
      params.append('_q', String(query));

    if (filters !== null && filters !== undefined && filters.length > 0) {
      filters.forEach(element => {
        params.append(element.key, String(element.value));
      });
    }

    const options = new RequestOptions({search: params, headers: this.headers});

    return this.http.get( `${this.apiUrl}/disabilities?${params}`, options);
  }

  public newDisability(formData: FormData): Observable<Response> {
    var headers: Headers = new Headers();
    if (tokenNotExpired()) {
        headers.append('Authorization', 'Bearer ' + localStorage.getItem('token'));
    }
    var options = new RequestOptions({ headers: headers });

    return this.http.post(`${this.apiUrl}/candidate-disabilite/`, formData, options);
  }

  public updateDisability(id: number, formData: FormData): Observable<Response> {
    var headers: Headers = new Headers();
    if (tokenNotExpired()) {
      headers.append('Authorization', 'Bearer ' + localStorage.getItem('token'));
    }
    var options = new RequestOptions({ headers: headers });

    return this.http.post( `${this.apiUrl}/disabilities/${id}`, formData , options );
  }

  public deleteDisability(id: number): Observable<Response> {
    return this.http.delete( `${this.apiUrl}/disabilities/${id}`, { headers: this.headers } );
  }

  public infoDisability(id: number): Observable<Response> {
    let params: URLSearchParams = new URLSearchParams();

    params.append('_with', String('disabilities_status,documents'));

    const options = new RequestOptions({search: params, headers: this.headers});

    return this.http.get( `${this.apiUrl}/disabilities/${id}?${params}`, options);
  }

  public newDisabilityAdmin(formData: FormData): Observable<Response> {
    var headers: Headers = new Headers();
    if (tokenNotExpired()) {
        headers.append('Authorization', 'Bearer ' + localStorage.getItem('token'));
    }
    var options = new RequestOptions({ headers: headers });

    return this.http.post(`${this.apiUrl}/disabilities`, formData, options);
  }

  public updateDisabilityAdmin(id: number, formData: FormData): Observable<Response> {
    var headers: Headers = new Headers();
    if (tokenNotExpired()) {
      headers.append('Authorization', 'Bearer ' + localStorage.getItem('token'));
    }
    var options = new RequestOptions({ headers: headers });

    return this.http.post( `${this.apiUrl}/disabilities/${id}`, formData , options );
  }

  public newCandidateDisabilityPublic(formData: FormData): Observable<Response> {
    return this.http.post(`${this.apiUrl}/upload-disabilty-public`, formData);
  }

  public getDocumentsDisabilityPublic(id: number, exp: string, sig: string): Observable<Response> {
    return this.http.get(`${this.apiUrl}/disability-correct-documents-public/${id}?exp=${exp}&sig=${sig}`);
  }

  public uploadCorrectDocumentsDisabilityPublic(formData: FormData, exp: string, sig: string): Observable<Response> {
    formData.append('exp', exp);
    formData.append('sig', sig);
    return this.http.post(`${this.apiUrl}/upload-disability-correct-documents-public`, formData);
  }

  public getDocumentsDisabilityPendingNotify(): Observable<Response> {
    var headers: Headers = new Headers();
    if (tokenNotExpired()) {
      headers.append('Authorization', 'Bearer ' + localStorage.getItem('token'));
    }
    var options = new RequestOptions({ headers: headers });
    return this.http.get(`${this.apiUrl}/disabilties/pending-notification-documents`, options);
  }

  public markDocumentsAsViewed(documentIds: number[]): Observable<Response> {
    var headers: Headers = new Headers();
    if (tokenNotExpired()) {
      headers.append('Authorization', 'Bearer ' + localStorage.getItem('token'));
    }
    headers.append('Content-Type', 'application/json');

    var options = new RequestOptions({ headers: headers });

    const body = {
      idsDocuments: documentIds
    };

    return this.http.post(`${this.apiUrl}/disabilties/view-notification-documents`, body, options)
  }

  public updateDisabilityDocumentCandidate(id: number, formData: FormData): Observable<Response> {
    var headers: Headers = new Headers();
    if (tokenNotExpired()) {
      headers.append('Authorization', 'Bearer ' + localStorage.getItem('token'));
    }
    var options = new RequestOptions({ headers: headers });

    return this.http.post( `${this.apiUrl}/candidate-update-documents-disabilities/${id}`, formData , options );
  }

}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/disability/services/candidate-disabilities.service.ts